<div class="table-responsive">
  <table class="table">
    <thead>
      <tr>
        <th translate>ID</th>
        <th translate>NAME</th>
        <th translate>PRICE</th>
        <th translate>AVAILABILITY</th>

        <th style="min-width: 200px"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of mappedData">
        <td *ngIf="item.replacementId == null">
          <a routerLink="/product/{{ item.id }}" class="text-dark">
            {{ item.id }}
          </a>
        </td>
        <td *ngIf="item.replacementId != null">
          <span [ngbPopover]="popContent2" triggers="mouseenter" [autoClose]="'outside'">
            <a routerLink="/product/{{ item.id }}" class="text-red">
              {{ item.id }} <i class="fas fa-exclamation-triangle"></i>
            </a>
          </span>
          <ng-template #popContent2>
            <div class="row">
              <div class="col text-center">
                <span translate>PRODUCT_REPLACED_BY</span> <br />
                <a routerLink="/product/{{ item.id }}" class="text-dark">
                  {{ item.replacementId }}
                </a>
              </div>
            </div>
          </ng-template>
        </td>
        <td>
          <a routerLink="/product/{{ item.id }}" class="text-dark">
            {{ item.name }}
          </a>
        </td>
        <td>
          <span *ngIf="item.price">
            <span *ngIf="item.price.customerDiscountPercent === 0" translate>NET_PRICE</span>
            <span>
              {{ item.price.customerGrossPrice.value | gungCurrency: item.price.customerGrossPrice.currencyCode }}
            </span>
            <span *ngIf="item.price.customerDiscountPercent !== 0">(-{{ item.price.customerDiscountPercent }}%)</span>
          </span>
        </td>
        <td>
          <lib-availability [availability]="item.availability" [product]="item.product"></lib-availability>
        </td>
        <td style="width: 200px">
          <cult-buy-btn
            [id]="item.id"
            [minimumOrderQuantity]="item.packageSize"
            [stepAmount]="item.packageSize"
            [product]="item.product"
          >
          </cult-buy-btn>
        </td>
      </tr>
    </tbody>
  </table>
</div>
